import { bool, func, number } from 'prop-types';
import React, { useState } from 'react';
import { Button, UncontrolledTooltip as Tooltip } from 'reactstrap';

import api from '../../REST/api';
import withApiRequest from '../../REST/with-api-request';
import RecreationConfirmation from './RecreationConfirmation';

function RecreateCampaignButton({ campaignId, onRequest, loading }) {
  const [toggle, setToggle] = useState(false);

  const toggleConfirmation = () => setToggle(!toggle);

  const onClick = () => {
    onRequest({ id: campaignId, data: {} }).catch(console.error); // eslint-disable-line no-console
    toggleConfirmation();
  };

  return (
    <>
      <Button
        id="opportunity-show--re-create-campaign"
        color="primary"
        disabled={loading}
        onClick={toggleConfirmation}
      >
        Re-create Campaign
      </Button>
      <Tooltip target="opportunity-show--re-create-campaign">
        After recreating the campaign, previous changes to the default campaign
        line briefings are gone.
      </Tooltip>
      <RecreationConfirmation
        toggle={toggle}
        setToggle={toggleConfirmation}
        onClick={onClick}
      />
    </>
  );
}
RecreateCampaignButton.propTypes = {
  campaignId: number.isRequired,
  onRequest: func.isRequired,
  loading: bool.isRequired,
};

export default withApiRequest({
  query: api.recreateCampaign,
  error: 'flash',
  successMessage: 'Campaign recreated',
})(RecreateCampaignButton);
